import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseAdvancePublicCompanyLeadProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useAdvancePublicCompanyLead = ({ id, onSuccess, onError }: UseAdvancePublicCompanyLeadProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['advancePublicCompanyLead'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/public/leads/${id}/advance`)
    },
    onSuccess,
    onError,
  })
}
